export const taskStatusMap = {
	0: '未知',
	1: '未开始',
	2: '进行中',
	3: '已完成'
}
